

export default function Pin({point}){
  
  return (
<svg width="32" height="38" viewBox="0 0 32 38" transform="scale(1.5)" className="cursor-pointer" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" className={`cat-${point.category}`} d="M26.1679 4.22299C32.429 10.1121 32.7389 19.9068 26.8498 26.1679C23.3163 29.9493 19.7828 33.7308 16.1873 37.5122C12.4678 33.9787 8.68635 30.3833 4.90489 26.8498C-1.35622 20.9606 -1.66617 11.166 4.22299 4.90489C10.1121 -1.35622 19.9068 -1.66617 26.1679 4.22299Z" fill="#009ADF"/>
<path fillRule="evenodd" clipRule="evenodd" d="M3.60309 15.5674C3.60309 8.9963 8.93433 3.66506 15.5054 3.66506C22.0765 3.66506 27.4077 8.9963 27.4077 15.5674C27.4077 22.1384 22.0765 27.4697 15.5054 27.4697C8.93433 27.4697 3.60309 22.1384 3.60309 15.5674Z" fill="white"/>
</svg>
  );
}